import { useEffect, createContext, useContext, RefObject } from 'react';
import { createGetInputId } from 'modules/frequencyManagement/commonUtils';
import noop from 'utils/noop';
import { FrequencyMode } from 'modules/frequencyManagement/lib/types';

type FocusState = {
  focusId: RefObject<string | null>;
  focus: (id: string) => void;
  setFocusIdForRootName: (mode: FrequencyMode, rootName: string | undefined) => void;
};

export const defaultState = {
  focusId: {
    current: null,
  },
  focus: noop,
  setFocusIdForRootName: noop,
};

export const FocusContext = createContext<FocusState>(defaultState);

export const useFocusContext = () => useContext(FocusContext);

export const useFocusOnMount = (mode: FrequencyMode, rootName?: string) => {
  const { focusId, focus } = useFocusContext();

  useEffect(() => {
    const getInputId = createGetInputId(mode);
    const id = getInputId(rootName);
    if (focusId.current === id) focus(id);
  }, [focusId.current]);
};
